// extracted by mini-css-extract-plugin
export default {"self":"IntroSection_self__pLqoA"};